import { useContext, createContext } from "react";
export const useDetailContext = () => {
    const context = useContext(DetailContext);
    if (context === undefined) {
        throw new Error("A component has been used outside of the Provider components");
    }
    return context;
};
export const DetailContext = createContext(undefined);
